module.exports = __webpack_public_path__ + "static/img_9836_dpp_optimized-2dcf1b7bb298235aad228a7780471f9c.jpg";